export default {
    items: [
        {
            name: '[[[Strona główna]]]',
            route: 'dashboard',
            icon: 'fa fa-fw fa-home'
        },
        {
            name: '[[[Moje konto]]]',
            icon: 'fa fa-fw fa-user',
            children: [
                {
                    name: '[[[Profil użytkownika]]]',
                    route: 'core-account-profile',
                    icon: 'fa fa-fw fa-user-circle'
                },
                {
                    name: '[[[Zmiana hasła]]]',
                    route: 'core-account-password',
                    icon: 'fa fa-fw fa-toggle-on'
                },
                {
                    name: '[[[Powiadomienia]]]',
                    route: 'core-account-notifications',
                    icon: 'fas fa-fw fa-envelope-open'
                }
            ]
        },
        {
            name: '[[[Administracja]]]',
            icon: 'fa fa-fw fa-desktop',
            namespace: 'Ideo.Core.App.Areas.Admin.Core.Controllers',
            children: [
                {
                    name: '[[[Użytkownicy]]]',
                    route: 'core-users',
                    icon: 'fa fa-fw fa-user',
                    auth: {all: ['UsersPermissions@View'], any: []},
                    children: [
                        {
                            name: '[[[Dodanie użytkownika]]]',
                            route: 'core-users-add',
                            visible: false
                        },
                        {
                            name: '[[[Edycja użytkownika]]]',
                            route: 'core-users-edit',
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Role i uprawnienia]]]',
                    route: 'core-roles',
                    icon: 'fa fa-fw fa-users',
                    auth: {all: ['RolesPermissions@View'], any: []},
                    children: [
                        {
                            name: '[[[Dodanie roli]]]',
                            route: 'core-roles-add',
                            visible: false
                        },
                        {
                            name: '[[[Edycja roli]]]',
                            route: 'core-roles-edit',
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Zespoły]]]',
                    route: 'core-teams',
                    icon: 'fas fa-fw fa-user-friends',
                    auth: {all: ['TeamsPermissions@View'], any: []},
                    children: [
                        {
                            name: '[[[Dodanie zespołu]]]',
                            route: 'core-teams-add',
                            visible: false
                        },
                        {
                            name: '[[[Edycja zespołu]]]',
                            route: 'core-teams-edit',
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Organizacja]]]',
                    route: 'core-units',
                    icon: 'fas fa-fw fa-sitemap',
                    auth: {all: ['OrganizationPermissions@View'], any: []},
                    children: [
                        {
                            name: '[[[Dodanie działu]]]',
                            route: 'core-units-add',
                            visible: false
                        },
                        {
                            name: '[[[Edycja działu]]]',
                            route: 'core-units-edit',
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Bezpieczeństwo]]]',
                    route: 'core-security',
                    icon: 'fas fa-fw fa-shield-alt',
                    auth: {all: ['AdminPermissions@Security'], any: []},
                },
                {
                    name: '[[[Historia logowania]]]',
                    route: 'core-authlog',
                    icon: 'fas fa-fw fa-file-import',
                    auth: {all: ['AdminPermissions@Authlog'], any: []},
                },
                {
                    name: '[[[Rejestr zmian]]]',
                    route: 'core-changelog',
                    icon: 'fas fa-fw fa-file-signature',
                    auth: {all: ['AdminPermissions@Changelog'], any: []},
                    children: [
                        {
                            name: '[[[Szczegóły zdarzenia]]]',
                            route: 'core-changelog-diff',
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Zastępstwa]]]',
                    route: 'core-substitutions',
                    icon: 'fa fa-fw fa-user',
                    auth: {all: ['SubstitutionsPermissions@View'], any: []},
                    children: [
                        {
                            name: '[[[Dodanie zastępstwa]]]',
                            route: 'core-substitutions-add',
                            visible: false
                        },
                        {
                            name: '[[[Edycja zastępstwa]]]',
                            route: 'core-substitutions-edit',
                            visible: false
                        }
                    ]
                },
            ]
        },
        {
            name: '[[[Struktura serwisu]]]',
            icon: 'fas fa-fw fa-globe',
            namespace: 'Ideo.Core.App.Areas.Admin.Cms.Controllers',
            children: [
                {
                    name: '[[[Strony]]]',
                    route: 'cms-pages',
                    icon: 'fas fa-fw fa-newspaper',
                    auth: {all: ['PagesPermissions@View'], any: []},
                    children: [
                        {
                            name: '[[[Dodanie strony]]]',
                            route: 'cms-pages-add',
                            visible: false
                        },
                        {
                            name: '[[[Edycja strony]]]',
                            route: 'cms-pages-edit',
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Aranżacje]]]',
                    route: 'cms-layouts',
                    icon: 'fas fa-fw fa-palette',
                    auth: {all: ['LayoutsPermissions@View'], any: []},
                },
                {
                    name: '[[[Witryny]]]',
                    route: 'cms-websites',
                    icon: 'fas fa-fw fa-newspaper',
                    auth: {all: ['WebsitesPermissions@View'], any: []},
                    children: [
                        {
                            name: '[[[Dodanie witryny]]]',
                            route: 'cms-websites-add',
                            visible: false
                        },
                        {
                            name: '[[[Edycja witryny]]]',
                            route: 'cms-websites-edit',
                            visible: false
                        }
                    ]
                }
            ]
        },
        {
            name: '[[[Moduły]]]',
            icon: 'fa fa-fw fa-cogs',
            namespace: 'Ideo.Core.App.Areas.Admin.Cms.Controllers',
            children: [
                // {
                //     name: '[[[Strony opisowe]]]',
                //     route: 'cms-articles',
                //     icon: 'far fa-fw fa-file',
                //     children: [
                //         {
                //             name: '[[[Dodanie wpisu]]]',
                //             route: 'cms-articles-add',
                //             visible: false
                //         },
                //         {
                //             name: '[[[Edycja wpisu]]]',
                //             route: 'cms-articles-edit',
                //             visible: false
                //         }
                //     ]
                // },
                {
                    name: '[[[Aktualności]]]',
                    route: 'cms-informations',
                    icon: 'far fa-fw fa-copy',
                    auth: {all: ['InformationsPermissions@View'], any: []},
                    children: [
                        {
                            name: '[[[Dodanie aktualności]]]',
                            route: 'cms-informations-add',
                            visible: false
                        },
                        {
                            name: '[[[Edycja aktualności]]]',
                            route: 'cms-informations-edit',
                            visible: false
                        }
                    ]
                }
            ]
        },
        {
            name: '[[[Repozytorium plików]]]',
            route: 'filemanager',
            icon: 'fa fa-fw fa-folder-open'
        }
    ]
};
